export default __webpack_public_path__ + "d0adc2b29b7472077dc7439642f1439a.ttf";